import { useContext } from "react"
import { CacheKeys } from "../CacheKeys"
import { UserPreferencesContext } from "../contexts/UserPreferencesContextProvider"

export const useActiveOrgId = (): string | undefined => {
  const { userPreferences } = useContext(UserPreferencesContext)
  return userPreferences?.[CacheKeys.UserPreferences.ActiveOrgId]
}
